import { render } from "./Layout.vue?vue&type=template&id=063de322"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "063de322"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('063de322', __exports__)) {
    api.reload('063de322', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=063de322", () => {
    api.rerender('063de322', render)
  })

}


export default __exports__